// api/getConfirmOrder.js

export const getConfirmOrder = async () => {
  try {
    const myHeaders = new Headers();
    myHeaders.append(
      "Accept",
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7"
    );

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    const endpoint = "/shop/confirm_order";
    const fullUrl = `${window.location.origin}${endpoint}`;
    const response = await fetch(fullUrl, requestOptions);
    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error fetching confirm order:", error);
    return null;
  }
};
